/**
 * WhatsappProvider compartido para microservicios A365
 * 
 * Proporciona acceso unificado al número de WhatsApp
 * basado en los datos de geolocalización.
 */

import React, { createContext, useContext, useEffect, useState } from "react";
import { processedGeo$ } from "../services/geolocationService";

const WhatsappContext = createContext();

export const useWhatsapp = () => {
  const context = useContext(WhatsappContext);
  if (!context) {
    throw new Error('useWhatsapp debe utilizarse dentro de un WhatsappProvider');
  }
  return context;
};

export const WhatsappProvider = ({ children }) => {
  const [whatsapp, setWhatsapp] = useState("");

  useEffect(() => {
    const subscription = processedGeo$.subscribe((data) => {
      if (data?.hasOwnProperty("sales_number")) {
        setWhatsapp(data.sales_number);
      }
    });

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  const value = {
    whatsapp_number: whatsapp,
  };

  return (
    <WhatsappContext.Provider value={value}>
      {children}
    </WhatsappContext.Provider>
  );
};

// Re-exportar el contexto
export { WhatsappContext };
